import React, { PropTypes } from 'react';
import Dropdown from 'common/components/Dropdown';
import { staticIconUrl } from '../../reducers/point';
import { Input } from 'semantic-ui-react';

const SHAPES = [
  {
    code: 'circle',
    icon: 'rond',
    label: 'Rond',
  },
  {
    code: 'square',
    icon: 'carre',
    label: 'Carré',
  },
  {
    code: 'diamond',
    icon: 'losange',
    label: 'Losange',
  },
  {
    code: 'hexagon',
    icon: 'hexagone',
    label: 'Hexagone',
  },
  {
    code: 'crest',
    icon: 'crest',
    label: 'Écusson',
  },
  {
    code: 'trapeze',
    icon: 'trapeze',
    label: 'Trapèze',
  },
];

const TERMITE_PRESENCES = [
  {
    code: 'NONE',
    label: 'Non',
  },
  {
    code: 'LOW',
    label: 'Faible',
  },
  {
    code: 'MEDIUM',
    label: 'Moyenne',
  },
  {
    code: 'HIGH',
    label: 'Forte',
  },
];

const renderShapeDefault = () => (
  <div className="default text">Forme géométrique</div>
);

const renderShapeItem = item => (
  <div key={item.code} data-value={item.code} className="item">
    <img
      src={staticIconUrl(item.icon)}
      alt="Forme géométrique"
      style={{ marginTop: '0px' }}
    />
    {item.label}
  </div>
);

const renderTermitePresenceDefault = () => (
  <div className="default text">Présence de termite</div>
);

const renderTermitePresenceItem = item => (
  <div key={item.code} data-value={item.code} className="item">
    {item.label}
  </div>
);

const PointForm = ({ point, disabled }) => (
  <form className="ui form">
    <div className="ui fields">
      <div className="eight wide field">
        <label>Nom</label>
        <input
          name="name"
          type="text"
          defaultValue={point.name}
          readOnly={disabled}
        />
      </div>
      <div className="eight wide field">
        <label>Consommation</label>
        <Input
          label={{ basic: true, content: '%' }}
          labelPosition="right"
          defaultValue={point.consumption}
          readOnly={disabled}
        />
      </div>
    </div>
    <div className="ui fields">
      <div className="eight wide field">
        <label>Présence de termite</label>
        <Dropdown
          name="termite_presence"
          value={point.termite_presence}
          items={TERMITE_PRESENCES}
          renderDefault={renderTermitePresenceDefault}
          renderItem={renderTermitePresenceItem}
          disabled={disabled}
        />
      </div>
      <div className="eight wide field">
        <label>Forme géométrique</label>
        <Dropdown
          name="shape"
          value={point.shape}
          items={SHAPES}
          renderDefault={renderShapeDefault}
          renderItem={renderShapeItem}
          disabled={disabled}
        />
      </div>
    </div>
  </form>
);

PointForm.propTypes = {
  point: PropTypes.object.isRequired,
};

export default PointForm;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/zones/plan/components/forms/PointForm.js